export enum AlarmState {
  OK_NO_ALARM = 'OK_NO_ALARM',
  UPPER_BOUND_MINOR = 'UPPER_BOUND_MINOR',
  UPPER_BOUND_MAJOR = 'UPPER_BOUND_MAJOR',
  LOWER_BOUND_MINOR = 'LOWER_BOUND_MINOR',
  LOWER_BOUND_MAJOR = 'LOWER_BOUND_MAJOR',
}
